// import * as React from 'react';
// import Paper from '@mui/material/Paper';
// import { Box, Stack, Typography, Zoom } from '@mui/material';
// import { lime } from '@mui/material/colors';
// import ParentBox from 'pages/components/ParentBox';
// import { formatDistance, repeatEffectSeq, settingsConfig } from 'utils/commonFunc';
// import ApiService from 'services/ApiService';
// import PolylineIcon from '@mui/icons-material/Polyline';
// import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
// import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
// import RepeatIcon from '@mui/icons-material/Repeat';
// import { ChipStack } from 'pages/components/ChipStack';
// import defColors from 'utils/defColors';

// const RouteDisplayItem = ({ item, seq }) => {

//     const onClickHandler = async (id) => {
//         const response = await ApiService.get(`dashboard/bis/PublishRouteListDetail?routeId=${id}`);
//         if (response.status === 200) {
//             const data = response.data;
//         }
//     }

//     return (
//         <Zoom in style={{ transitionDelay: true ? `${seq * 10}ms` : '0ms' }}>
//             <Paper variant='outlined' sx={{ position: 'relative', minHeight: '120px', p: '20px 14px', backgroundColor: 'var(--gs-90)', cursor:'pointer' , borderRadius:'10px' }} 
//                 onClick={() => onClickHandler(item.routeId)}>
//                 <Stack
//                     direction={'row'}
//                     justifyContent={'space-between'}
//                     alignItems="center"
//                     sx={{ mb: 1 }}
//                 >
//                     <Stack direction={'row'} alignItems="center" spacing={1}>
//                         <PolylineIcon />
//                         <Typography variant='h6' color={defColors.bus[`code${item.routeTp}`]}>{item.routeNm}</Typography>
//                     </Stack>
//                     <Typography sx={{fontSize:'20px;', letterSpacing:'-1px'}}>{item.startStationName} - {item.endStationName} ({formatDistance(item.routeDistance)})</Typography>
//                 </Stack>
//                 <Box sx={{ width: '100%', backgroundColor: 'blue' }}>
//                     <Box sx={{ width: '100%', height: 5, backgroundColor: '#494D60', mt: 4 }} />
//                     <Box sx={{ width: '100%', position: 'relative',  }}>
//                         {item.stations &&
//                             item.stations.map((station, idx) => {
//                                 const x = `${(idx / item.stations.length * 100)}%`
//                                 if (station.stationType !== 3)
//                                     return <ArrowDropUpIcon key={idx} fontSize='small' sx={{ position: 'absolute', bottom: 0, marginBottom: -2, marginLeft: '-5px', left: x, color: defColors.bus.station }} />
//                                 else
//                                     return <RepeatIcon key={idx} fontSize='small' sx={{ position: 'absolute', bottom: 0, marginBottom: -2, marginLeft: '-5px', left: x, color: lime[300] }} />
//                             })
//                         }
//                         {/* <PlaceIcon fontSize='small' sx={{position:'absolute', bottom:0, left:'20%', color: blue[300]}}/> */}
//                     </Box>
//                     <Box sx={{ width: '100%', position: 'relative' }}>
//                         {item.vehicles &&
//                             item.vehicles.map((vehicle) => {
//                                 const ordIndex = item.stations.findIndex(station => station.stationOrd === vehicle.lastStationOrd);
//                                 const x = `${(ordIndex / item.stations.length * 100)}%`
//                                 return <DirectionsBusIcon key={vehicle.vehId} fontSize='small' sx={{ position: 'absolute', bottom: 0, left: x, color: defColors.bus[`code${item.routeTp}`] }} />
//                             })
//                         }
//                     </Box>
//                 </Box>
//             </Paper>
//         </Zoom>
//     )
// }

// export default function BisRouteDetailView(props) {
//     const { columnsCount } = props
//     const [currentData, setCurrentData] = React.useState()
//     const [groupData, setGroupData] = React.useState()
//     const elementRef = React.useRef(null);

//     const chipStyleBusRoute= {
//         position: 'absolute',
//         top: '-86px', 
//         right: '0', 
//         zIndex:'10',
//     };

//     React.useEffect(() => {
//         const params = new URLSearchParams(window.location.search);
//         const columns = columnsCount ?? params.get("count") ?? 2;
//         let createdData
//         return repeatEffectSeq(
//             async (seq) => {
//                 if (seq === 0) {
//                     const response = await ApiService.get("dashboard/bis/GetRouteDetailList");
//                     if (response.status === 200) {
//                         const data = response.data;
//                         if (data && elementRef.current?.clientHeight) {
//                             const data = response.data;
//                             console.log('data :::',data)
//                             const count = Math.floor((elementRef.current.clientHeight) / 86) * columns;
//                             //setCurrentData(data.slice(0, count))
//                             const newArray = Array.from({ length: Math.ceil(data.length / count) }, (value, index) => {
//                                 const start = index * count;
//                                 const end = start + count;
//                                 return data.slice(start, end);
//                             });
//                             createdData = newArray.map((p, idx) => ({ idx, groupName: `그룹${idx + 1}`, items: p }))
//                             setGroupData(createdData)
//                         }
//                     }
//                 }

//                 if (createdData?.length > 0) {
//                     setCurrentData(createdData[seq])
//                     return createdData.length;
//                 }
//                 else return 0
//             },
//             settingsConfig().contentUpdateDelaySec)
//     }, [columnsCount]);

//     return (
//         <ParentBox title={'노선 상세 정보'} sx={{porsition:'relative'}}>
//             {groupData?.length > 1 &&
//                 <ChipStack
//                     textItems={groupData.map(p => p.groupName)}
//                     selectedText={currentData?.groupName}
//                     sx={chipStyleBusRoute}
//                     chipSx={{ minWidth: '140px', width: 'fit-content' }} 
//                 />
//             }
//             <Box sx={{ height: '100%', width: '100%', p: 2, pt: 4 }}>
//                 <Box
//                     ref={elementRef}
//                     //direction="column"
//                     direction="column" useFlexGap flexWrap="wrap"
//                     className="busRouteScrollWrap cst_scroll"
//                     justifyContent="flex-start"
//                     alignItems="stretch"
//                     spacing={1}
//                     sx={{
//                         height: 'calc(100% - 20px)', // 타이틀 제외 영역
//                         overflowY: 'auto',
//                         display: 'grid',
//                         gridTemplateColumns: '1fr 1fr', // 2열
//                         gap: '20px',
//                         paddingRight: '10px', // 스크롤바와 내용 사이 간격
//                     }}
//                     >
//                     {currentData?.items?.map((item, seq) => <RouteDisplayItem key={item.routeId} item={item} seq={seq}/>)}
//                 </Box>
//             </Box>
//         </ParentBox>
//     )
// }


import * as React from 'react';
import Paper from '@mui/material/Paper';
import { Box, Stack, Typography, Zoom } from '@mui/material';
import { lime } from '@mui/material/colors';
import ParentBox from 'pages/components/ParentBox';
import { formatDistance, repeatEffectSeq, settingsConfig } from 'utils/commonFunc';
import ApiService from 'services/ApiService';
import PolylineIcon from '@mui/icons-material/Polyline';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import RepeatIcon from '@mui/icons-material/Repeat';
import defColors from 'utils/defColors';

const StatusTypeChip = ({ children, selected, onClick, sx }) => {
    return (
        <Paper
            variant="outlined"
            onClick={onClick}
            sx={{
                position: 'relative',
                p: 2,
                pl: 2,
                pr: 2,
                borderRadius: '16px',
                borderColor: 'transparent',
                minWidth: '140px',
                backgroundColor: defColors.chipSelectedColorFunc(selected),
                color: defColors.chipSelectedfont(selected),
                cursor: 'pointer',
                ...sx,
            }}
        >
            <Typography variant={selected ? 'h5' : 'h6'} textAlign={'center'}>{children}</Typography>
        </Paper>
    );
};

export default function BisRouteDetailView(props) {
    const { columnsCount } = props;
    const [currentData, setCurrentData] = React.useState();
    const [groupData, setGroupData] = React.useState();
    const [selectedGroupIndex, setSelectedGroupIndex] = React.useState(0);
    const elementRef = React.useRef(null);

    React.useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const columns = columnsCount ?? params.get("count") ?? 2;
        let createdData;

        return repeatEffectSeq(
            async (seq) => {
                if (seq === 0) {
                    const response = await ApiService.get("dashboard/bis/GetRouteDetailList");
                    if (response.status === 200) {
                        const data = response.data;
                        if (data && elementRef.current?.clientHeight) {
                            const count = Math.floor((elementRef.current.clientHeight) / 86) * columns;
                            const newArray = Array.from({ length: Math.ceil(data.length / count) }, (v, i) => data.slice(i * count, (i + 1) * count));
                            createdData = newArray.map((p, idx) => ({ idx, groupName: `그룹${idx + 1}`, items: p }));
                            setGroupData(createdData);
                        }
                    }
                }

                if (createdData?.length > 0) {
                    setCurrentData(createdData[seq]);
                    setSelectedGroupIndex(seq);
                    return createdData.length;
                } else return 0;
            },
            settingsConfig().contentUpdateDelaySec
        );
    }, [columnsCount]);

    return (
        <ParentBox title={'노선 상세 정보'} sx={{ position: 'relative' }}>
            <Box sx={{ height: '100%', width: '100%', p: 2, pt: 4 }}>
                {groupData?.length > 1 &&
                    <Box sx={{ position: 'absolute', top: '-86px', right: 0, zIndex: 10 }}>
                        <Stack direction="row" spacing={1.5}>
                            {groupData.map((group, idx) => (
                                <StatusTypeChip
                                    key={group.groupName}
                                    selected={selectedGroupIndex === idx}
                                    onClick={() => {
                                        setCurrentData(group);
                                        setSelectedGroupIndex(idx);
                                    }}
                                >
                                    {group.groupName}
                                </StatusTypeChip>
                            ))}
                        </Stack>
                    </Box>
                }
                <Box
                    ref={elementRef}
                    className="busRouteScrollWrap cst_scroll"
                    // sx={{
                    //     maxHeight: 'calc(100% - 20px)', // 타이틀 제외 영역
                    //     minHeight: 'calc(100% - 20px)', // 타이틀 제외 영역
                    //     overflowY: 'auto',
                    //     display: 'flex',
                    //     gridTemplateColumns: '2fr 2fr',
                    //     gap: '20px',
                    //     paddingRight: '10px',
                    //     //direction: 'column',
                    //     useFlexGap: true,
                    //     flexWrap: 'wrap',
                    // }}
                    sx={{
                        maxHeight: 'calc(100% - 20px)',
                        minHeight: 'calc(100% - 20px)',
                        overflowY: 'auto',
                        display: 'grid',  // flex → grid로 변경
                        gridTemplateColumns: 'repeat(2, 1fr)', // 2열 그리드
                        gap: '20px',
                        paddingRight: '15px',
                        alignContent: 'flex-start', // 내용을 상단 정렬
                    }}
                >
                    {currentData?.items?.map((item, seq) => (
                        <RouteDisplayItem key={item.routeId} item={item} seq={seq} sx={{ width: '50%' }} />
                    ))}
                </Box>
            </Box>
        </ParentBox>
    );
}

const RouteDisplayItem = ({ item, seq, sx }) => {
    const onClickHandler = async (id) => {
        const response = await ApiService.get(`dashboard/bis/PublishRouteListDetail?routeId=${id}`);
        if (response.status === 200) {
            const data = response.data;
            // Handle data
        }
    };

    return (
        <Zoom in style={{ transitionDelay: true ? `${seq * 10}ms` : '0ms' }} sx={{ width: '100%', backgroundColor: 'var(--gs-90)',borderRadius: '10px' , p: '12px 14px', minHeight: '120px' }}>
            <Paper
                variant='outlined'
                sx={{ position: 'relative' }}
                onClick={() => onClickHandler(item.routeId)}
            >
                <Stack direction={'row'} justifyContent={'space-between'} alignItems="center" sx={{ mb: 1 }}>
                    <Stack direction={'row'} alignItems="center" spacing={1}>
                        <PolylineIcon />
                        <Typography variant='h6' color={defColors.bus[`code${item.routeTp}`]}>{item.routeNm}</Typography>
                    </Stack>
                    <Typography sx={{ fontSize: '20px', letterSpacing: '-1px' }}>{item.startStationName} - {item.endStationName} ({formatDistance(item.routeDistance)})</Typography>
                </Stack>
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ width: '100%', height: 5, backgroundColor: '#494D60', mt: 4 }} />
                    <Box sx={{ width: '100%', position: 'relative' }}>
                        {item.stations && item.stations.map((station, idx) => {
                            const x = `${(idx / item.stations.length * 100)}%`
                            return station.stationType !== 3 ? (
                                <ArrowDropUpIcon key={idx} fontSize='small' sx={{ position: 'absolute', bottom: 0, marginBottom: -2, marginLeft: '-5px', left: x, color: defColors.bus.station }} />
                            ) : (
                                <RepeatIcon key={idx} fontSize='small' sx={{ position: 'absolute', bottom: 0, marginBottom: -2, marginLeft: '-5px', left: x, color: lime[300] }} />
                            )
                        })}
                    </Box>
                    <Box sx={{ width: '100%', position: 'relative' }}>
                        {item.vehicles && item.vehicles.map((vehicle) => {
                            const ordIndex = item.stations.findIndex(station => station.stationOrd === vehicle.lastStationOrd);
                            const x = `${(ordIndex / item.stations.length * 100)}%`
                            return <DirectionsBusIcon key={vehicle.vehId} fontSize='small' sx={{ position: 'absolute', bottom: 0, left: x, color: defColors.bus[`code${item.routeTp}`] }} />
                        })}
                    </Box>
                </Box>
            </Paper>
        </Zoom>
    );
};
